export const REFERRER_FORM_URL = 'https://forms.gle/MLyoAn3Bq3vAvfEt7'

export const STORE_FORM_URL = 'https://forms.gle/VNHZ2EFcLwumoCxP8'
